export function setsAreEqual(a, b) {
    if (a === b)
        return true;
    if (a.size !== b.size)
        return false;
    for (const key of a) {
        if (!b.has(key))
            return false;
    }
    return true;
}
export function setsEqualIfEmpty(a, b) {
    return a === b || (a.size === 0 && b.size === 0);
}
